// What the product calls itself, wherever a person can see it.
//
// One variable, `APP_NAME`, set on the deployment: the server reads it at run
// time and Vite bakes it into this bundle at build time (see vite.config.ts and
// the Dockerfile's ARG). The fallback is the name today, so a development build
// with nothing set still says something.
//
// The wordmark is lowercase by CSS (`.wordmark`), so this is written the way it
// is spelled and rendered the way it is drawn.
export const APP_NAME = import.meta.env.APP_NAME || "Hugo";
